import { createVeriffFrame, MESSAGES } from '@veriff/incontext-sdk'

import {
    useEffect
} from 'react'

import { useNavigate } from 'react-router-dom'

const PreCheck = ({
    data,
}) => {

    const navigate = useNavigate()

    useEffect(() => {
        if (!data?.sessionUrl) {
            return
        }
        createVeriffFrame({
            url: data.sessionUrl,
            embedded: true,
            embeddedOptions: {
                rootElementID: 'embedded-container',
            },
            onEvent: function (msg) {
                switch (msg) {
                    case MESSAGES.STARTED:
                        console.log('Verification started');
                        break;
                    case MESSAGES.SUBMITTED:
                        navigate('/pre-check-form-success')
                        break;
                    case MESSAGES.FINISHED:
                        console.log('Verification finished');
                        break;
                    case MESSAGES.CANCELED:
                        console.log('Verification closed');
                        break;
                    case MESSAGES.RELOAD_REQUEST:
                        console.log('Verification reloaded');
                        break;
                }
            },
        })

    }, [data?.sessionUrl])

    return (
        <div className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">Identity Verification</h1>
                    <p className="text-gray-700 text-base">
                        Please complete the identity verification steps below.
                    </p>
                </div>

                <div className="w-full md:w-[635px] h-auto md:h-[670px] min-h-[670px]" id="embedded-container" />

                {!data?.sessionUrl && (
                    <p className="text-sm text-red-600">
                        Session does not exist or has expired. Please contact support.
                    </p>
                )}
            </div>
        </div>
    )

}

export default PreCheck
